<template>
  <v-row class="ma-0 tabStyle" :class="{ changeTab: active }">
    <!--
    <v-col cols="12" class="text-center" v-if="type === 'parLeave'"
      >육아휴직 사용일수 {{ useDay }}일</v-col
    >
    -->
    <!--신청가능일수-->
    <v-col class="mt-4 mb-8 pa-0" v-if="GET_APPL_CD !== '153' && GET_APPL_CD !== '154' && GET_APPL_CD !== '156' && GET_APPL_CD !== '157'
    && GET_APPL_CD !== '158' && GET_APPL_CD !== '159'"
           >
      <v-list-item
          class="apply_list elevation-2"
      >
        <v-list-item-content class="apply_list_num pr-4" >
          <v-list-item-title>신청가능일</v-list-item-title>
          <v-list-item-subtitle>{{
              this.GET_REMAIN_DAYS_BEFORE===0?this.limitTerm:this.GET_REMAIN_DAYS_BEFORE
            }}</v-list-item-subtitle>
          <v-list-item-subtitle>일</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content class="apply_list_divider">|</v-list-item-content>
        <v-list-item-content class="apply_list_num pl-4"  v-if="GET_APPL_CD === '151'">
          <v-list-item-title>기신청일수</v-list-item-title>
          <v-list-item-subtitle>{{ this.GET_PER_DAY }}</v-list-item-subtitle>
          <v-list-item-subtitle>일</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" v-if="true" class="text-center tabItem">
      <span class="startDay">시작일</span>
      <span class="mx-4 title-line">-</span>
      <span class="endDay">종료일</span>
    </v-col>

    <!-- <v-col cols="6" class="text-center tabItem startDay">시작일</v-col> -->
    <!-- <v-col cols="6" class="text-center tabItem endDay">종료일</v-col> -->
    <v-col cols="12" class="text-center calendar-title" v-else>날짜선택</v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getLeaAbsEtcDaysAppDet,
  getExtParAddAppDetMap,
} from '@/api/workStatus';
import dayjs from 'dayjs';

export default {
  data: () => ({
    limitTerm: '',
    caDays: '',
    type: '',
    useDay: '',
  }),
  props: {
    activeTab: {
      type: String,
    },
  },
  computed: {
    ...mapGetters([
      'GET_APPL_CD',
      'GET_APPL_SEQ',
      'GET_ORG_APPL_SEQ',
      'GET_APPL_TYPE',
      'GET_PER_DAY',
      'GET_REMAIN_DAYS_BEFORE',
    ]),

    active() {
      if (this.activeTab === 'S') {
        return false;
      } else if (this.activeTab === 'E') {
        return true;
      } else {
        return null;
      }
    },
  },

  async mounted() {

    this.type = this.GET_APPL_TYPE;

    if (this.type === 'parLeave') {
      let params = {
        searchApplSeq: this.GET_APPL_SEQ,
        searchApplSeq2: this.GET_ORG_APPL_SEQ,
      };

      let response = await getExtParAddAppDetMap(params);
      console.dir('getExtParAddAppDetMap : '+response);
      //this.SET_E_YMD(response.data.data.orgTmpRestEndPlanYmd);
      if (response.data.data != null) {
        this.useDay = response.data.data.orgCaDays;
      }

    } else {
      let params = {
        applCd: this.GET_APPL_CD,
      };

      let response = await getLeaAbsEtcDaysAppDet(params);
      this.limitTerm = response.data.data.limitTerm.limitTerm;
      this.caDays = response.data.data.caDays.caDays;

      //this.$store.commit('SET_LIMIT_TERM', parseInt(this.limitTerm));

      this.$store.commit('SET_LIMIT_TERM', parseInt(this.GET_REMAIN_DAYS_BEFORE===0?this.limitTerm:this.GET_REMAIN_DAYS_BEFORE));
      //this.$store.commit('SET_USED_DAYS_BEFORE', parseInt(this.limitTerm) - parseInt(this.caDays));
      this.$store.commit('SET_USED_DAYS_BEFORE', parseInt(this.GET_REMAIN_DAYS_BEFORE) - parseInt(this.GET_PER_DAY));
      //this.$store.commit('SET_CA_DAYS', parseInt(this.caDays));
      this.$store.commit('SET_CA_DAYS', parseInt(this.GET_PER_DAY));

    }
  },
};
</script>

<style>
.tabStyle .tabItem {
  padding: 15px 0px;
  font-size: 1.125rem;
  background-color: #f9fafa;
}
.tabStyle .tabItem .title-line {
  font-weight: bold;
  color: #3cb149;
}
.tabStyle .startDay {
  font-weight: bold;
  color: #3cb149;
}
.tabStyle .endDay {
  font-weight: 400;
  color: #979b9f;
}
.tabStyle.changeTab .startDay {
  font-weight: 400;
  color: #979b9f;
}
.tabStyle.changeTab .endDay {
  font-weight: bold;
  color: #3cb149;
}
</style>
